<template>
  <div class="maintainers">
    <div class="columns mb-0">
      <div class="column component-title">{{ title }}</div>
      <div class="column">
        <b-checkbox class="is-pulled-right" v-model="excludeExternalCorrespondents" v-if="editable">
          {{ $t('docflow.excludeExternalCorrespondents') }}
        </b-checkbox>
      </div>
    </div>
    <b-autocomplete
        v-if="editable"
        class="user-search"
        type="text"
        icon="magnify"
        v-model="searchQuery"
        :data="correspondents"
        :placeholder="$t('docflow.inputNameToAdd')"
        field="title"
        :loading="loading"
        @input="search"
        @select="add">
      <template slot-scope="props">
        <div class="media-content">
          <template v-if="props.option.type === 'new'">
            {{ $t('docflow.addNewCorespondent', {name: props.option.name}) }}
          </template>
          <template v-else>{{ props.option.name }}</template>
        </div>
      </template>
    </b-autocomplete>
    <b-table :data="data" class="maintainers-table">
      <template slot-scope="props">
        <b-table-column :label="$t('docflow.correspondent.name')" field="name" sortable>
          {{ props.row.name }}
        </b-table-column>
        <b-table-column :label="$t('tasks.actions')" width="120" :visible="editable">
          <a @click.prevent="remove(props.row.id)">
            <b-icon icon="trash-can-outline" size="is-small"></b-icon> {{ $t('interface.remove') }}
          </a>
        </b-table-column>
      </template>
      <template slot="empty">
        <section class="section">
          <div class="content is-fluid has-text-grey has-text-centered">
            <p>
              <span class="has-text-grey-light">{{ $t('docflow.correspondentsAddTip') }}</span>
            </p>
          </div>
        </section>
      </template>
    </b-table>
  </div>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import {debounce} from '@/utils'
  import BCheckbox from "buefy/src/components/checkbox/Checkbox";

  export default {
    components: {BCheckbox},
    props: ['items', 'editable', 'type', 'title', 'canAddExternal'],
    data() {
      return {
        data: this.items,
        searchQuery: null,
        scope: 'all',
        excludeExternalCorrespondents: false
      }
    },
    methods: {
      search: debounce(function () {
        this.$store.dispatch('Reference/getCorrespondents', {
          searchQuery: this.searchQuery,
          scope: this.scope,
          canAddExternal: this.canAddExternal
        })
      }),
      remove(correspondentId) {
        this.$emit('remove', correspondentId)
      },
      add(correspondent) {
        this.$emit('add', correspondent)
      }
    },
    computed: {
      ...mapState('Reference', ['loading', 'correspondents'])
    },
    watch: {
      items(val) {
        this.data = val
      },
      excludeExternalCorrespondents(checked) {
        this.scope = !checked ? 'all' : 'systemObjectsAndOrganizationGroups'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .maintainers {
    .maintainers-table {
      margin-top: 10px;
      border: 1px solid #E6E8F1;

      thead {
        background: #f6f6f6;
        td, th {
          border-width: 0 0 1px;
        }
      }

      .table {
        border: 0;
      }
    }

    .component-title {
      font-size: 16px !important;
      font-weight: bold;
    }

    .user-search {
      margin-bottom: 4px;
    }

    .user-image {
      display: block;
      border-radius: 50%;
    }
  }
</style>
